var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"text-center\"><button type=\"button\" class=\"btn-link btn btn-block btn-sm\" ng-click=\"$ctrl.layer.contain($ctrl.designer.design, 100)\">Fill within the design (contain)</button> <button type=\"button\" class=\"btn-link btn btn-block btn-sm\" ng-click=\"$ctrl.layer.cover($ctrl.designer.design, 100)\">Fit on top of the design (cover)</button></div>";
var id1="design-layer-popover.scale.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;